import * as PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslate } from '@tolgee/react';

export function Pagination({ pageRows, total, nextPageCallBack }) {
  const { t } = useTranslate();
  const [numbers, setNumbers] = useState(() =>
    Array(Math.ceil(total / pageRows))
      .fill()
      .map((_, i) => i)
  );
  useEffect(() => {
    setNumbers(() =>
      Array(Math.ceil(total / pageRows))
        .fill()
        .map((_, i) => i)
    );
  }, [total, pageRows]);

  const [selectedPage, setSelectedPage] = useState(0);
  const selectPage = (e, i) => {
    e.preventDefault();
    if (i < Math.ceil(total / pageRows) && i > -1) {
      setSelectedPage(i);
      nextPageCallBack(i + 1);
    }
  };
  function getNeighbours(arr, i) {
    if (i >= arr.length - 1) {
      return arr.slice(-3);
    } else if (i === 0) {
      return arr.slice(0, 3);
    } else {
      return arr.slice(i - 1, i + 2);
    }
  }

  return (
    <ul className="pagination">
      <li
        className={`page-item previous cursor-pointer ${
          selectedPage < 1 ? 'disabled' : ''
        }`}
        onClick={(e) => selectPage(e, selectedPage - 1)}
      >
        <a className="page-link" aria-label={t('pagination.previous', 'Previous')}>
          <i className="previous"></i>
          <span className="visually-hidden">{t('pagination.previous', 'Previous')}</span>
        </a>
      </li>
      {getNeighbours(numbers, selectedPage).map((i) => (
        <li
          className={`page-item cursor-pointer ${
            selectedPage === i ? 'active' : ''
          }`}
          key={i}
          onClick={(e) => selectPage(e, i)}
        >
          <a className="page-link" onClick={(e) => e.preventDefault()}>
            {i + 1}
          </a>
        </li>
      ))}
      <li
        className={`page-item next  cursor-pointer ${
          selectedPage >= Math.ceil(total / pageRows) - 1 ? 'disabled' : ''
        }`}
        onClick={(e) => selectPage(e, selectedPage + 1)}
      >
        <a className="page-link" aria-label={t('pagination.next', 'Next')}>
          <i className="next"></i>
          <span className="visually-hidden">{t('pagination.next', 'Next')}</span>
        </a>
      </li>
    </ul>
  );
}
Pagination.propTypes = {
  total: PropTypes.number.isRequired,
  pageRows: PropTypes.number.isRequired,
  nextPageCallBack: PropTypes.func.isRequired
};
